export enum League {
  Little = "little",
  Great = "great",
  Ultra = "ultra",
  Master = "master",
}
